export * from './dashboard.component';
export * from './dashboard.service';
export * from './profile/profile.component';
export * from './editprofile/editProfile.component';
//# sourceMappingURL=index.js.map